//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

export interface SyncCookBookItemPayload {
  isbridger: boolean;
  issync: boolean;
  sitecodes: string[];
}

export const syncCookBookItem = createAsyncThunk(
  'itemMaster/syncCookBookItem',
  async (sitecodes: string[]) => {
    const payload: SyncCookBookItemPayload = {
      isbridger: true,
      issync: true,
      sitecodes,
    };

    const response = await axiosInstance.post(
      `${BASE_URL}/api/v1/ItemMaster/SyncCookBookItem`,
      payload
    );

    return response.data;
  }
);

const initialState = {
  loading: false,
  error: null as string | null,
};

const itemMasterSlice = createSlice({
  name: 'itemMaster',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(syncCookBookItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(syncCookBookItem.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(syncCookBookItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to sync cookbook items';
      });
  },
});

export default itemMasterSlice.reducer;
